var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_1821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.67773H3.5C2.11929 1.67773 1 2.79702 1 4.17773V9.17773C1 10.5584 2.11929 11.6777 3.5 11.6777H8.5C9.88071 11.6777 11 10.5584 11 9.17773V4.17773C11 2.79702 9.88071 1.67773 8.5 1.67773Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99985 6.36276C8.06156 6.77889 7.99048 7.20387 7.79673 7.57727C7.60298 7.95067 7.29643 8.25347 6.92067 8.4426C6.54491 8.63173 6.11908 8.69756 5.70375 8.63073C5.28842 8.5639 4.90473 8.3678 4.60727 8.07034C4.30981 7.77288 4.11372 7.3892 4.04689 6.97387C3.98005 6.55854 4.04589 6.13271 4.23502 5.75695C4.42415 5.38119 4.72695 5.07463 5.10035 4.88088C5.47375 4.68713 5.89873 4.61606 6.31485 4.67776C6.73932 4.74071 7.13228 4.93849 7.4357 5.24192C7.73912 5.54534 7.93691 5.9383 7.99985 6.36276Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.92773H8.755",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_1821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.677734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.e7808f9e8add07479f46a8863c567e3e.svg";
export { ForwardRef as ReactComponent };